<dashboardnav>
  <cradua-group
  [groups]="groups$ | async"
  (group)="onSubmitGroup($event)"
  (deleteGroupEvent)="onDeleteGroup($event)"
  *ngIf="(isLoadingGroup$ | async ) === false"
  >
</cradua-group>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingGroup$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
